import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/media/data/Documents/code/javascript/mdxp/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "present"
    }}>{`Present`}</h1>
    <p>{`Presenting with MDXP should be pretty self-explanatory, but if you ever need some help, you can press `}<inlineCode parentName="p">{`ALT+H`}</inlineCode>{` to show all the possible keybindings.`}</p>
    <p>{`MDXP supports various display modes, which can help you during your presentation.
What's more is that you can open your presentation in different tab pages, and each of them can be in a different display mode.
This allows you to show your presentation in fullscreen for your audience, while having the presenter mode with all your notes open on your own screen.
Whenever you navigate to the next slide on your screen, the presentation will automatically advance on any other open tab on your computer.`}<br parentName="p"></br>{`
`}{`The different modes that are available in MDXP are:`}</p>
    <ul>
      <li parentName="ul">{`Normal Mode : this is the default mode, which simply shows your slides (`}<inlineCode parentName="li">{`ATL+N`}</inlineCode>{` to toggle).`}</li>
      <li parentName="ul">{`Grid Mode : this mode allows you to see an overview of your presentation, and quickly navigate to a certain slide (`}<inlineCode parentName="li">{`ALT+G`}</inlineCode>{` to toggle).`}</li>
      <li parentName="ul">{`Presenter Mode : this mode allows you to see the current slide, as well as a preview of the next step. It also shows your presenter notes, as well as a timer (`}<inlineCode parentName="li">{`ALT+P`}</inlineCode>{` to toggle).`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`NOTE`}</strong><br parentName="p"></br>{`
`}{`You can disable MDXP's mode navigation or slide navigation keybindings, by setting the `}<inlineCode parentName="p">{`modeNavigation`}</inlineCode>{` and `}<inlineCode parentName="p">{`slideNavigation`}</inlineCode>{` arguments of the `}<a parentName="p" {...{
          "href": "/MDXP/core-components#deck"
        }}>{`Deck`}</a>{` component.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      